import { render, staticRenderFns } from "./ProfessionalExperience.vue?vue&type=template&id=27531fc2&scoped=true&"
import script from "./ProfessionalExperience.vue?vue&type=script&lang=js&"
export * from "./ProfessionalExperience.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalExperience.vue?vue&type=style&index=0&id=27531fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27531fc2",
  null
  
)

export default component.exports